import { AuditChannel } from "@common/types/auditLog";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { toVisibleChannel } from "../components/historyActivityFilters";
import { useIsChannelAttributionEnabled } from "./useIsChannelAttributionEnabled";

export function useVisibleHistoryChannel(
    channel: AuditChannel | null | undefined,
): AuditChannel | undefined {
    const isChannelAttributionEnabled = useIsChannelAttributionEnabled();
    const { agentRuns: isAgentRunsEnabled } = useTypedFlags();

    return toVisibleChannel({
        channel,
        isChannelAttributionEnabled,
        isAgentRunsEnabled,
    });
}
